<template>
    <CopyPasteCode :code="account.tracker_script || ''" />
    <div class="btn-s btn-1 validate-tracker-button" :disabled="loading" v-if="enableValidation && !status" @click="validateTracker"><span v-if="!loading">{{$t('components.validateTracker.button_validate')}}</span><div v-if="loading" class="loading-spinner-type-1"></div></div>
    <div class="notice" :class="[status ? 'success' : 'error']" v-if="loaded && !loading">{{$t(status ? 'components.validateTracker.notices.success' : 'components.validateTracker.notices.error')}}</div>
    <div class="notice" v-if="!(loaded && !loading && status)">{{$t('components.validateTracker.notices.installation')}}</div>
</template>

<script>
    import { useAccountStore } from '@/stores/account';
    import CopyPasteCode from '@/components/elements/misc/CopyPasteCode';

    export default {
        name: 'TrackerSettings',
        components: {
            CopyPasteCode
        },
        props: {
            enableValidation: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                status: null,
                loaded: false,
                loading: false
            };
        },
        computed: {
            account() {
                return useAccountStore().account;
            }
        },
        methods: {
            async validateTracker() {
                this.loading = true;
                this.loaded = false;
                const response = await useAccountStore().validateTracker();                
                this.loading = false;
                this.loaded = true;

                if(response && !response.tracker_installed) {
                    this.status = true;
                    return true;
                } else {
                    this.status = false;
                    return false;
                }
            }
        }
    }
</script>